import React, { useEffect, useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import { Card } from "react-bootstrap";
import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "../components/SignInButton";
import { SignOutButton } from "../components/SignOutButton";
import axios from "../configuration/axios";
import { useMsal } from "@azure/msal-react";
import { loginRequestProd, loginRequestDev } from "../authConfig";
import { InteractionStatus } from "@azure/msal-browser";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { CountrySelectionDropdown } from "../components/CountrySelectionDropdown";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";
import { useNavigate } from "react-router-dom";
import { Text } from "@fluentui/react";

function FulfillmentPage(props) {
  const { setTokenExpired, tokenExpired, hasAdminSignedInAndSubscription } =
    props;
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [isActivating, setIsActivating] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [isProvisioned, setIsProvisioned] = useState(false);
  let authMsalToken = localStorage.getItem("msalToken");

  const navigate = useNavigate();

  useEffect(async () => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let queryAuthCode = params.get("token");
    localStorage.setItem("authCode", queryAuthCode);

    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      await RequestToken();
    }
  }, [isAuthenticated, inProgress, instance]);

  function setCountry(country) {
    setSelectedCountry(country);
  }

  function redirectToMainPage() {
    navigate("/");
  }

  async function activateSubscription() {
    setIsActivating(true);
    await provisionSubscription();
    setIsActivating(false);
  }

  async function provisionSubscription() {
    if (accounts.length > 0) {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("msalToken")}`,
        }, //probably not needed
      };
      const bodyParameters = {
        authCode: localStorage.getItem("authCode"),
        msalAccountPayload: accounts[0],
        location: selectedCountry,
      };
      var resData;
      await axios
        .post(
          axios.defaults.baseURL + "/Subscription/ResolveAuthCode",
          bodyParameters,
          config
        )
        .then((result) => {
          setTokenExpired(false);
          resData = result.data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            setTokenExpired(true);
          }
        });
      await postActivation(resData);
    }
  }

  async function postActivation(resData) {
    if (resData && resData.id) {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("msalToken")}`,
        },
      };
      const bodyParameters = {
        subscriptionId: resData.id,
      };

      await axios
        .post(
          axios.defaults.baseURL + "/Subscription/ActivateSubscription",
          bodyParameters,
          config
        )
        .then((result) => {
          setTokenExpired(false);
          setIsProvisioned(true);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            setTokenExpired(true);
          }
        });
    }
  }

  const name = accounts[0] && accounts[0].name;


  async function RequestToken() {
    let request;

    if(process.env.NODE_ENV === 'production') {
      request = {
        ...loginRequestProd,
        account: accounts[0],
      };
    }
    else {
      request = {
        ...loginRequestDev,
        account: accounts[0],
      };
    }

    await instance
      .acquireTokenPopup(request)
      .then((response) => {
        localStorage.setItem("msalToken", response.accessToken);
        authMsalToken = response.accessToken;
      })
      .catch((e) => {
      });
  }

  return (
    <>
      <Navbar
        style={{
          justifyContent: "left",
          borderBottom: "2px",
          borderColor: "black",
          backgroundColor: "#0066CC",
        }}
        variant="dark"
      >
        <a className="navbar-brand" href="/" style={{ marginLeft: "1rem" }}>
          novaCapta Compass Subscription Management
        </a>
        {isAuthenticated ? <SignOutButton setTokenExpired={setTokenExpired} /> : <SignInButton />}
      </Navbar>
      <h5 style={{ marginTop: "2rem", height: "100vh" }}>
        <center>
          {isProvisioned && isAuthenticated ? (
            <div>
              <Card style={{ width: "50rem", marginTop: "2rem" }}>
                <Card.Body>
                  <Card.Title>
                    <h1>Success.</h1>
                  </Card.Title>
                  <Card.Text style={{ marginBottom: "2rem" }}>
                    Your subscription has been provisioned successfully. <br />
                    You can now access the management system to assign licenses
                    to your employees.
                  </Card.Text>
                  <Card.Footer style={{ backgroundColor: "white" }}>
                    <PrimaryButton
                      style={{ marginLeft: "40rem", marginTop: "0.5rem" }}
                      onClick={redirectToMainPage}
                    >
                      Go
                    </PrimaryButton>
                  </Card.Footer>
                </Card.Body>
              </Card>
            </div>
          ) : (
            <div>
              {isActivating && isAuthenticated ? (
                <div style={{ marginTop: "3rem" }}>
                  <Spinner
                    size={SpinnerSize.large}
                    label="Provisioning. Please wait..."
                  />
                </div>
              ) : isAuthenticated ? (
                <div>
                  Welcome to the Subscription Management Center for novaCapta
                  Compass, {name}
                  <Card style={{ width: "50rem", marginTop: "2rem" }}>
                    <Card.Body>
                      <Card.Title>
                        <h1>Your purchase has been confirmed.</h1>
                      </Card.Title>
                      <Card.Text>
                        Please select your location to finish your account
                        setup.
                      </Card.Text>
                      <div style={{ marginBottom: "2rem", marginTop: "3rem" }}>
                        <CountrySelectionDropdown setCountry={setCountry} />
                      </div>
                      <Card.Footer style={{ backgroundColor: "white" }}>
                        <PrimaryButton
                          style={{ marginLeft: "40rem", marginTop: "0.5rem" }}
                          onClick={activateSubscription}
                          disabled={selectedCountry === null}
                        >
                          Provision
                        </PrimaryButton>
                      </Card.Footer>
                    </Card.Body>
                  </Card>
                </div>
              ) : null}
            </div>
          )}
        </center>
      </h5>
      <Navbar
        style={{
          justifyContent: "center",
          marginTop: "3.5rem",
          borderColor: "black",
          backgroundColor: "#0066CC",
        }}
        variant="dark"
      >
        <Text style={{ color: "white" }}>©2021 novaCapta GmbH</Text>
      </Navbar>
    </>
  );
}

export default FulfillmentPage;
